import React from 'react';
import { trackFbCustom } from '../utils/fbPixel';
import { useTrackSection } from '../utils/useTrackSection';
export function Footer() {
  useTrackSection('footer', 'Footer Section');
  return <footer id="footer" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    backgroundColor: 'rgb(255,255,255)',
    borderTopColor: 'rgba(0,119,182,0.20)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-150">
      <div className="mx-auto max-w-4xl text-center" data-id="element-151">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px]" style={{
        color: '#0077B6'
      }} data-id="element-152">
          🦴 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-153">
          El sistema N°1 para kinesiólogos que quieren trabajar con criterio
          clínico, cobrar lo que merecen y crecer en Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-154">
          "Porque ejercer la kinesiología con excelencia clínica no debería
          demandarte todas tus noches y fines de semana."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-155">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline text-gray-600 transition-colors" style={{
          ['--hover-color' as any]: '#0077B6'
        }} onClick={() => trackFbCustom('ContactClick', {
          method: 'email'
        })} onMouseEnter={e => (e.target as HTMLElement).style.color = '#0077B6'} onMouseLeave={e => (e.target as HTMLElement).style.color = ''} data-id="element-156">
            📧 construyeprogresoo@gmail.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-157">|</span>
          <span className="text-gray-600" data-id="element-158">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-200" data-id="element-159">|</span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline text-gray-600 transition-colors" onClick={() => trackFbCustom('ContactClick', {
          method: 'website'
        })} onMouseEnter={e => (e.target as HTMLElement).style.color = '#0077B6'} onMouseLeave={e => (e.target as HTMLElement).style.color = ''} data-id="element-160">
            🌐 www.construyeprogreso.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24" style={{
        backgroundColor: 'rgba(0,119,182,0.30)'
      }} data-id="element-161" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-162">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-163">
            © {new Date().getFullYear()} Construye Progreso™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-164">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}